import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import LogoComponent from "./LogoComponent";
import BeforeLoginContent from "./BeforeLoginContent";
import AfterLoginContent from "./AfterLoginContent";
import LanguageSwitcher from "./LanguageSwitcher";
import TranslatesContent from "../../DataStore/Languages/translatesContent";
import { useNotification, useNotifyView } from "../../services/notification";
import { LOGOUTURL } from "../../DataStore/ApiConstant";
import {
  UserData,
  clearTournamentEligibility,
  fetchTournamentEligibility,
  fetchTournamentPoints,
  fundTransfer,
} from "../../DataStore";

const HeaderComponent = ({
  login,
  openPopup,
  userData,
  getUserData,
  openGeneralModal,
  fundsTransfer,
  setSelectedGameType,
  tournamentPoints,
  getTournamentPoints,
  tournamentEligibility,
  getTournamentEligibility,
  clearTournamentEligibilityState,
}) => {
  const userDta = userData.data.data1;
  const userSession = userData.data.session;

  const userDropdown = useRef(null);
  const mobileuserDropdown = useRef(null);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] =
    useState(false);
  const [isNotificationUpdating, setIsNotificationUpdating] = useState(false);
  const history = useHistory();
  const notification = useNotification();

  useEffect(() => {
    if (login) {
      getTournamentPoints();
      getTournamentEligibility();
    } else {
      clearTournamentEligibilityState();
    }
  }, [
    login,
    getTournamentPoints,
    getTournamentEligibility,
    clearTournamentEligibilityState,
  ]);

  const isTournamentEligible = Boolean(tournamentEligibility?.eligible);

  const handleTournamentClick = (e) => {
    e.preventDefault();

    if (!login) {
      openPopup("login");
      return;
    }

    if (typeof setSelectedGameType === "function") {
      if (history.location?.pathname !== "/lobby") {
        history.push("/lobby");
      }
      setSelectedGameType("BallysTournament");
      return;
    }

    history.push("/BallysTournament");
  };

  const openUserDropdown = () => {
    userDropdown.current?.classList?.toggle("show-userMenu");
    mobileuserDropdown.current?.classList?.toggle("show-userMenu");
  };

  const logoutUser = (e) => {
    e.preventDefault();
    axios
      .get(LOGOUTURL)
      .then(() => {
        localStorage.removeItem("login");
        history.push("/");
      })
      .catch(() => {});
  };

  const notifyView = useNotifyView({
    onSuccess: () => {
      notification.refetch();
    },
  });

  const handleNotificationClick = async (notificationId) => {
    if (isNotificationUpdating) {
      return;
    }
    setIsNotificationUpdating(true);

    try {
      await notifyView.mutateAsync(notificationId);
      notification.refetch();
    } finally {
      setIsNotificationUpdating(false);
    }

    setIsNotificationDropdownOpen(false);
  };

  const toggleNotificationDropdown = () => {
    setIsNotificationDropdownOpen((prev) => !prev);
  };

  return (
    <>
      <div className="d-none d-sm-block fixed-top bg-dark">
        <div className="d-flex flex-wrap justify-content-around  justify-content-lg-start bg-dark align-self-center">
          <div className="p-2 flex-grow-1">
            <LogoComponent login={login} />
          </div>

          

          {login && isTournamentEligible && (
            <div class="item align-self-center">
              <a href="#" onClick={handleTournamentClick}>
                <div class="item align-self-center"><span class="flashy-tournament-text">🏆 Congratulations </span>
            </div>
                {/* <div class="tPointsBox">
                  <TranslatesContent contentKey="tournament-head-tag" /> |{" "}
                  <span class="scoreboardNumber">
                    <div class="flap-container">
                      {String(tournamentPoints?.points || 0)
                        .padStart(6, "0")
                        .split("")
                        .map((digit, index) => (
                          <div
                            key={index}
                            class="flap text-center d-flex align-items-center justify-content-center"
                          >
                            {digit}
                          </div>
                        ))}
                    </div>
                  </span>
                </div> */}
              </a>
            </div>
          )}

          <div className="pt-lg-2 pt-0 px-2 pb-2">
            <LanguageSwitcher />
          </div>

          {!login ? (
            <BeforeLoginContent openLoginPopup={openPopup} />
          ) : (
            <AfterLoginContent
              userDta={userDta}
              userSession={userSession}
              openPopup={openPopup}
              openGeneralModal={openGeneralModal}
            />
          )}
        </div>
      </div>

      {!login ? (
        <div className="d-flex d-block d-sm-none fixed-top bg-dark">
          <>
            <div className="p-2 flex-grow-1">
              <LogoComponent login={login} />
            </div>
            <div className="pt-lg-1 pt-0 px-2 pb-2">
              <LanguageSwitcher />
            </div>
            <BeforeLoginContent openLoginPopup={openPopup} />
          </>
        </div>
      ) : (
        <div className="container-fluid d-block d-sm-none fixed-top bg-dark">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="d-flex align-items-center align-self-center">
                  <div className="me-auto p-2">
                    <LogoComponent login={login} />
                  </div>
                  <div className="p-2">
                    <LanguageSwitcher mobile={true} />
                  </div>
                  <div className="p-2">
                    <a
                      href="#"
                      className="position-relative icon nav-list__item notification"
                      style={{ margin: "0px" }}
                    >
                      <span className="icon" onClick={toggleNotificationDropdown}>
                        <i className="fa fa-bell" />
                        <span className="total">
                          {" "}
                          {notification.data && notification.data.notifyCount}
                        </span>
                      </span>
                      {isNotificationDropdownOpen && (
                        <ul class="drop-down">
                          {notification.isError === false &&
                            notification?.data?.userNotify?.length > 0 && (
                              <>
                                {notification?.data?.userNotify?.map(
                                  (userNotification) => (
                                    <li
                                      class="drop-down__item"
                                      key={userNotification.id}
                                      onClick={() =>
                                        handleNotificationClick(userNotification.id)
                                      }
                                    >
                                      {userNotification.notification}
                                    </li>
                                  )
                                )}
                              </>
                            )}
                          {notification.isError === false &&
                            notification?.data?.commonNotify?.length > 0 && (
                              <>
                                {notification?.data?.commonNotify?.map(
                                  (commonNotification) => (
                                    <li
                                      class="drop-down__item"
                                      key={commonNotification.id}
                                      onClick={() =>
                                        handleNotificationClick(commonNotification.id)
                                      }
                                    >
                                      {commonNotification.notification}
                                    </li>
                                  )
                                )}
                              </>
                            )}

                          {notification.isError === false &&
                            (!notification?.data?.userNotify ||
                              notification?.data?.userNotify?.length === 0) &&
                            (!notification?.data?.commonNotify ||
                              notification?.data?.commonNotify?.length === 0) && (
                              <li class="drop-down__item">
                                <TranslatesContent contentKey="No-notifications-available" />
                              </li>
                            )}
                        </ul>
                      )}
                    </a>
                  </div>
                  <div className="p-2">
                    <span className="icon">
                      <a
                        href=""
                        className=" icon"
                        id="defaultDropdown2"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasRight"
                        aria-controls="offcanvasRight"
                      >
                        <i className="fa fa-user"></i>
                      </a>
                    </span>
                  </div>

                  <div className="p-2">
                    <a
                      href=""
                      onClick={(e) => logoutUser(e)}
                      className="heder-rounded-icon"
                    >
                      <i className="fa fa-power-off"></i>
                    </a>
                  </div>
                </div>

                <div className="d-flex align-items-center">
                  <div className="p-2 me-auto">
                    <Link to={"/cashier"}>
                      <button type="button" class="btn btn-warning joinTopbutton text-end">
                        <TranslatesContent contentKey="deposit" />
                      </button>
                    </Link>
                  </div>

                  {/* <div class="item align-self-center">
                    <a href="#" onClick={handleTournamentClick}>
                      <div class="tPointsBox">
                        <TranslatesContent contentKey="tournament-head-tag" /> |{" "}
                        <span class="scoreboardNumber">
                          <div class="flap-container">
                            {String(tournamentPoints?.points || 0)
                              .padStart(6, "0")
                              .split("")
                              .map((digit, index) => (
                                <div
                                  key={index}
                                  class="flap text-center d-flex align-items-center justify-content-center"
                                >
                                  {digit}
                                </div>
                              ))}
                          </div>
                        </span>
                      </div>
                    </a>
                  </div> */}
                            {login && isTournamentEligible && (
            <div class="item align-self-center">
              <a href="#" onClick={handleTournamentClick}>
                <div class="item align-self-center"><span class="flashy-tournament-text">🏆 Congratulations </span>
            </div>
                {/* <div class="tPointsBox">
                  <TranslatesContent contentKey="tournament-head-tag" /> |{" "}
                  <span class="scoreboardNumber">
                    <div class="flap-container">
                      {String(tournamentPoints?.points || 0)
                        .padStart(6, "0")
                        .split("")
                        .map((digit, index) => (
                          <div
                            key={index}
                            class="flap text-center d-flex align-items-center justify-content-center"
                          >
                            {digit}
                          </div>
                        ))}
                    </div>
                  </span>
                </div> */}
              </a>
            </div>
          )}

                  <div className="p-2" style={{ whiteSpace: "nowrap" }}>
                    <li className="nav-list__item notification">
                      LKR{" "}
                      {fundsTransfer &&
                        fundsTransfer.data.data &&
                        new Intl.NumberFormat().format(
                          Math.max(
                            0,
                            fundsTransfer.data.data.wallet.balance -
                              fundsTransfer.data.data.bonus_given.balance
                          )
                        )}
                      <ul className="drop-down">
                        <li className="drop-down__item">
                          <span className="title">
                            <TranslatesContent contentKey="wallet_balance" />
                          </span>
                          <span className="value">
                            {fundsTransfer &&
                              fundsTransfer.data &&
                              fundsTransfer.data.data.wallet &&
                              new Intl.NumberFormat().format(
                                fundsTransfer.data.data.wallet.fundBalance
                              )}
                          </span>
                        </li>
                        <li className="drop-down__item">
                          <span className="title">
                            <TranslatesContent contentKey="Last-Bonus-balance-area" />
                          </span>
                          <span className="value">
                            {" "}
                            {fundsTransfer &&
                              fundsTransfer.data &&
                              fundsTransfer.data.data.bonus_given &&
                              new Intl.NumberFormat().format(
                                fundsTransfer.data.data.bonus_given.balance
                              )}
                          </span>
                        </li>
                        <li className="drop-down__item">
                          <span className="title">
                            <TranslatesContent contentKey="otp-balance-area" />
                          </span>
                          <span className="value">
                            {fundsTransfer &&
                              fundsTransfer.data &&
                              fundsTransfer.data.data.otpcash &&
                              new Intl.NumberFormat().format(
                                fundsTransfer.data.data.otpcash.balance
                              )}
                          </span>
                        </li>
                        <li className="drop-down__item">
                          <span className="title">
                            <TranslatesContent contentKey="non-cash-balance-area" />
                          </span>
                          <span className="value">
                            {fundsTransfer &&
                              fundsTransfer.data &&
                              fundsTransfer.data.data.noncash &&
                              new Intl.NumberFormat().format(
                                fundsTransfer.data.data.noncash.balance
                              )}
                          </span>
                        </li>
                      </ul>
                    </li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const setStatetoProps = (state) => {
  return {
    userData: state.userData,
    LanguageContent: state.SiteLanguages,
    fundsTransfer: state.FundTransfers,
    tournamentPoints: state.TournamentPoints,
    tournamentEligibility: state.TournamentEligibility,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getFUndTransfers: () => dispatch(fundTransfer()),
    getUserData: () => dispatch(UserData()),
    getTournamentPoints: () => dispatch(fetchTournamentPoints()),
    getTournamentEligibility: () => dispatch(fetchTournamentEligibility()),
    clearTournamentEligibilityState: () => dispatch(clearTournamentEligibility()),
  };
};

export default connect(setStatetoProps, mapDispatchToProps)(HeaderComponent);
